try {
    if (process.env.TOKENS_FEATURE_FLAG === 'true' || process.env.STORYBOOK_TOKENS_FEATURE_FLAG !== 'false') require('./index-new.css');
    else require('./index.css');
  } catch (e) {
    if (e.code !== 'MODULE_NOT_FOUND') {
      throw e; // Re-throw unexpected errors
    }
    console.warn('index.css / index-new.css not found, proceeding without it.');
  }


import { jsx } from 'react/jsx-runtime';
import { Image } from '@design-system/image';

const ExtendableImage = ({ props, element, className, }) => {
    if (element)
        return element;
    if (props)
        return jsx(Image, Object.assign({ className: className }, props));
    return null;
};

export { ExtendableImage };
